var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadcomplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_147_3743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.4453,
    y: 10.4453,
    width: 36.1094,
    height: 36.1094,
    rx: 18.0547,
    fill: "#D8EAF9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_147_3743",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 17C26.1585 17 21 22.1585 21 28.5C21 34.8415 26.1585 40 32.5 40C38.8415 40 44 34.8415 44 28.5C44 26.22 43.3301 24.0947 42.1816 22.3057L41.4971 23.1143C42.4446 24.6913 43 26.53 43 28.5C43 34.2895 38.2895 39 32.5 39C26.7105 39 22 34.2895 22 28.5C22 22.7105 26.7105 18 32.5 18C35.2215 18 37.697 19.0499 39.5645 20.7549L40.2188 19.9824C38.1762 18.1299 35.4675 17 32.5 17ZM41.6182 19.877L31.957 31.2773L27.8906 27.4844L27.209 28.2158L32.042 32.7236L42.3818 20.5234L41.6182 19.877Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 17C26.1585 17 21 22.1585 21 28.5C21 34.8415 26.1585 40 32.5 40C38.8415 40 44 34.8415 44 28.5C44 26.22 43.3301 24.0947 42.1816 22.3057L41.4971 23.1143C42.4446 24.6913 43 26.53 43 28.5C43 34.2895 38.2895 39 32.5 39C26.7105 39 22 34.2895 22 28.5C22 22.7105 26.7105 18 32.5 18C35.2215 18 37.697 19.0499 39.5645 20.7549L40.2188 19.9824C38.1762 18.1299 35.4675 17 32.5 17ZM41.6182 19.877L31.957 31.2773L27.8906 27.4844L27.209 28.2158L32.042 32.7236L42.3818 20.5234L41.6182 19.877Z",
    fill: "#004276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1816 22.3057L46.3892 19.6045L42.7356 13.9132L38.3656 19.0749L42.1816 22.3057ZM41.4971 23.1143L37.681 19.8835L35.3659 22.6181L37.2112 25.6893L41.4971 23.1143ZM39.5645 20.7549L36.1932 24.4474L40.0257 27.9464L43.3797 23.9865L39.5645 20.7549ZM40.2188 19.9824L44.034 23.2141L47.158 19.526L43.5778 16.2788L40.2188 19.9824ZM41.6182 19.877L44.8488 16.0608L41.0345 12.8319L37.8036 16.6444L41.6182 19.877ZM31.957 31.2773L28.5466 34.9337L32.3813 38.5105L35.7715 34.5099L31.957 31.2773ZM27.8906 27.4844L31.3011 23.828L27.6431 20.416L24.2328 24.0756L27.8906 27.4844ZM27.209 28.2158L23.5511 24.807L20.1438 28.4633L23.7986 31.8722L27.209 28.2158ZM32.042 32.7236L28.6316 36.38L32.4661 39.9566L35.8564 35.9564L32.042 32.7236ZM42.3818 20.5234L46.1962 23.7562L49.4308 19.9397L45.6124 16.7072L42.3818 20.5234ZM32.5 17V12C23.3971 12 16 19.3971 16 28.5H21H26C26 24.9199 28.9199 22 32.5 22V17ZM21 28.5H16C16 37.6029 23.3971 45 32.5 45V40V35C28.9199 35 26 32.0801 26 28.5H21ZM32.5 40V45C41.6029 45 49 37.6029 49 28.5H44H39C39 32.0801 36.0801 35 32.5 35V40ZM44 28.5H49C49 25.2261 48.0352 22.1684 46.3892 19.6045L42.1816 22.3057L37.9741 25.0068C38.6251 26.0209 39 27.2139 39 28.5H44ZM42.1816 22.3057L38.3656 19.0749L37.681 19.8835L41.4971 23.1143L45.3131 26.345L45.9977 25.5364L42.1816 22.3057ZM41.4971 23.1143L37.2112 25.6893C37.7168 26.531 38 27.4854 38 28.5H43H48C48 25.5746 47.1723 22.8515 45.783 20.5392L41.4971 23.1143ZM43 28.5H38C38 31.5281 35.5281 34 32.5 34V39V44C41.0509 44 48 37.0509 48 28.5H43ZM32.5 39V34C29.4719 34 27 31.5281 27 28.5H22H17C17 37.0509 23.9491 44 32.5 44V39ZM22 28.5H27C27 25.4719 29.4719 23 32.5 23V18V13C23.9491 13 17 19.9491 17 28.5H22ZM32.5 18V23C33.9067 23 35.1961 23.5371 36.1932 24.4474L39.5645 20.7549L42.9357 17.0623C40.1978 14.5627 36.5363 13 32.5 13V18ZM39.5645 20.7549L43.3797 23.9865L44.034 23.2141L40.2188 19.9824L36.4035 16.7508L35.7492 17.5232L39.5645 20.7549ZM40.2188 19.9824L43.5778 16.2788C40.6546 13.6275 36.7611 12 32.5 12V17V22C34.1739 22 35.6979 22.6323 36.8597 23.686L40.2188 19.9824ZM41.6182 19.877L37.8036 16.6444L28.1425 28.0448L31.957 31.2773L35.7715 34.5099L45.4327 23.1095L41.6182 19.877ZM31.957 31.2773L35.3675 27.621L31.3011 23.828L27.8906 27.4844L24.4802 31.1407L28.5466 34.9337L31.957 31.2773ZM27.8906 27.4844L24.2328 24.0756L23.5511 24.807L27.209 28.2158L30.8669 31.6246L31.5485 30.8932L27.8906 27.4844ZM27.209 28.2158L23.7986 31.8722L28.6316 36.38L32.042 32.7236L35.4524 29.0672L30.6194 24.5594L27.209 28.2158ZM32.042 32.7236L35.8564 35.9564L46.1962 23.7562L42.3818 20.5234L38.5675 17.2907L28.2276 29.4909L32.042 32.7236ZM42.3818 20.5234L45.6124 16.7072L44.8488 16.0608L41.6182 19.877L38.3876 23.6931L39.1512 24.3396L42.3818 20.5234Z",
    fill: "#004276",
    mask: "url(#path-3-inside-1_147_3743)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_147_3743",
    x: 0,
    y: 0,
    width: 65,
    height: 65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_147_3743"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_147_3743",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadcomplete);
export default __webpack_public_path__ + "static/media/upload complete.fdafe87816e93d092da59ff215d85a8f.svg";
export { ForwardRef as ReactComponent };